<!-- modal detalle del postulante v-if="editedItem.id" -->
<template>
  <ComunDialogComp v-model="estado" max-width="1250" title="Ver detalle" @close-modal="cerrarModal">

    <template v-slot:body>
      <v-form ref="formDatos" lazy-validation>
        <template>
          <v-stepper v-model="stepCurrent" non-linear>
            <v-stepper-header>
              <v-stepper-step editable step="1">
                Datos de los padres
              </v-stepper-step>

              <v-stepper-step editable step="2">
                Datos del postulante
              </v-stepper-step>

              <v-stepper-step editable step="3">
                Documentos requeridos
              </v-stepper-step>

              <v-stepper-step editable step="4"> Cursos a cargo </v-stepper-step>
            </v-stepper-header>

            <v-stepper-items>
              <v-stepper-content step="1">
                <v-row class="py-0">
                  <v-col cols="12" sm="12" md="12" class="pb-0">
                    <v-alert dense border="left" class="text-center" color="#0277bd" dark>
                      <h3>Datos personales</h3>
                    </v-alert>
                  </v-col>
                  <v-col cols="12" lg="3">
                    <v-select v-model="postulante.familiar.id_tipo_pariente" :items="parentescos"
                      item-text="desc_tipos_parientes" item-value="id" label="Parentesco" readonly></v-select>
                  </v-col>
                  <v-col cols="12" lg="3">
                    <v-select v-model="postulante.familiar.id_tipo_documento" :items="getTipoDocumentos"
                      item-text="desc_tipo_documento" item-value="id" label="Tipo documento de identidad" readonly></v-select>
                  </v-col>
                  <v-col cols="12" lg="3">
                    <v-text-field label="Número de documento de identidad" v-model="postulante.familiar.numdoc_familiar"
                      readonly></v-text-field>
                  </v-col>
                  <v-col cols="12" lg="3">
                    <v-text-field label="Nombres" v-model="postulante.familiar.nombre_familiar" readonly></v-text-field>
                  </v-col>
                  <v-col cols="12" lg="3">
                    <v-text-field label="Apellido paterno" v-model="postulante.familiar.ape1_familiar"
                      readonly></v-text-field>
                  </v-col>
                  <v-col cols="12" lg="3">
                    <v-text-field label="Apellido materno" v-model="postulante.familiar.ape2_familiar"
                      readonly></v-text-field>
                  </v-col>
                  <v-col cols="12" lg="3">
                    <v-text-field v-model="postulante.familiar.fecnac_familiar" label="Fecha de nacimiento" type="date"
                      readonly></v-text-field>
                  </v-col>
                  <v-col cols="12" lg="3">
                    <v-select v-model="postulante.familiar.id_pais_nacimiento" :items="getPaises" item-text="nombre_pais"
                      item-value="id" label="País de nacimiento" readonly></v-select>
                  </v-col>
                  <v-col cols="12" lg="3">
                    <v-select v-model="postulante.familiar.id_nacionalidad" :items="nacionalidades"
                      item-text="desc_nacionalidad" item-value="id" label="Nacionalidad" readonly></v-select>
                  </v-col>
                  <v-col cols="12" lg="3">
                    <v-select v-model="postulante.familiar.sexo_familiar" :items="sexos" item-text="nombre"
                      item-value="abbr" label="Sexo" readonly></v-select>
                  </v-col>
                  <v-col cols="12" lg="3">
                    <v-select v-model="postulante.familiar.id_estado_civil" :items="getEstadosCiviles"
                      item-text="desc_estado_civil" item-value="id" label="Estado civil" readonly></v-select>
                  </v-col>
                  <v-col cols="12" lg="3">
                    <v-checkbox label="Apoderado" v-model="postulante.familiar.es_encargado" readonly></v-checkbox>
                  </v-col>
                  <v-col cols="12" lg="3">
                    <v-select v-model="postulante.familiar.id_pais" :items="getPaises" item-text="nombre_pais"
                      item-value="id" label="País" readonly></v-select>
                  </v-col>
                  <v-col cols="12" lg="3">
                    <v-select v-model="postulante.familiar.id_ubicacion1" :items="departamentosFamiliar"
                      item-text="nombre_ubicacion1" item-value="id" label="Departamento" readonly></v-select>
                  </v-col>
                  <v-col cols="12" lg="3">
                    <v-select v-model="postulante.familiar.id_ubicacion2" :items="provinciasFamiliar"
                      item-text="nombre_ubicacion2" item-value="id" label="Provincia" readonly></v-select>
                  </v-col>
                  <v-col cols="12" lg="3">
                    <v-select v-model="postulante.familiar.id_ubicacion3" :items="distritosFamiliar"
                      item-text="nombre_ubicacion3" item-value="id" label="Distrito" readonly></v-select>
                  </v-col>
                  <v-col cols="12" lg="3">
                    <v-text-field v-model="postulante.familiar.observacion_domicilio" label="Dirección"
                      readonly></v-text-field>
                  </v-col>
                  <v-col cols="12" lg="3">
                    <v-text-field v-model="postulante.familiar.cel_familiar" label="Teléfono móvil" readonly></v-text-field>
                  </v-col>
                  <v-col cols="12" lg="3">
                    <v-text-field v-model="postulante.familiar.telf_familiar" label="Teléfono fijo" readonly></v-text-field>
                  </v-col>
                  <v-col cols="12" lg="3">
                    <v-text-field v-model="postulante.familiar.correo_familiar" label="Correo electrónico" readonly></v-text-field>
                  </v-col>
                </v-row>
              </v-stepper-content>

              <v-stepper-content step="2">
                <v-row class="py-0">
                  <v-col cols="12" sm="12" md="12" class="pb-0">
                    <v-alert dense border="left" class="text-center" color="#0277bd" dark>
                      <h3>Datos del postulante</h3>
                    </v-alert>
                  </v-col>
                  <v-col cols="12" lg="3">
                    <v-text-field label="Año académico" v-model="postulante.condicion.admision.ano_academico"
                      readonly></v-text-field>
                  </v-col>
                  <v-col cols="12" lg="3">
                    <v-select v-model="postulante.familiar.id_tipo_documento" :items="getTipoDocumentos"
                      item-text="desc_tipo_documento" item-value="id" label="Tipo documento de identidad" readonly></v-select>
                  </v-col>
                  <v-col cols="12" lg="3">
                    <v-text-field label="Número de documento de identidad" v-model="postulante.numdoc_postulante"
                      readonly></v-text-field>
                  </v-col>
                  <v-col cols="12" lg="3">
                    <v-text-field label="Nombres" v-model="postulante.nombre_postulante" readonly></v-text-field>
                  </v-col>
                  <v-col cols="12" lg="3">
                    <v-text-field label="Apellido paterno" v-model="postulante.ape1_postulante" readonly></v-text-field>
                  </v-col>
                  <v-col cols="12" lg="3">
                    <v-text-field label="Apellido materno" v-model="postulante.ape2_postulante" readonly></v-text-field>
                  </v-col>
                  <v-col cols="12" lg="3">
                    <v-text-field v-model="postulante.fecnac_postulante" label="Fecha de nacimiento" type="date"
                      readonly></v-text-field>
                  </v-col>
                  <v-col cols="12" lg="3">
                    <v-select v-model="postulante.id_pais_nacimiento" :items="getPaises" item-text="nombre_pais"
                      item-value="id" label="País de nacimiento" readonly></v-select>
                  </v-col>
                  <v-col cols="12" lg="3">
                    <v-select v-model="postulante.familiar.id_nacionalidad" :items="nacionalidades"
                      item-text="desc_nacionalidad" item-value="id" label="Nacionalidad" readonly></v-select>
                  </v-col>
                  <v-col cols="12" lg="3">
                    <v-select v-model="postulante.familiar.sexo_familiar" :items="sexos" item-text="nombre"
                      item-value="abbr" label="Sexo" readonly></v-select>
                  </v-col>
                  <v-col cols="12" lg="3">
                    <v-text-field v-model="postulante.condicion.nivel.desc_nivel" label="Nivel" readonly></v-text-field>
                  </v-col>
                  <v-col cols="12" lg="3">
                    <v-text-field v-model="postulante.grado.grado.desc_grado" label="Grado" readonly></v-text-field>
                  </v-col>
                  <v-col cols="12" lg="3">
                    <v-select v-model="postulante.id_pais" :items="getPaises" item-text="nombre_pais" item-value="id"
                      label="País" readonly></v-select>
                  </v-col>
                  <v-col cols="12" lg="3">
                    <v-select v-model="postulante.id_ubicacion1" :items="departamentos" item-text="nombre_ubicacion1"
                      item-value="id" label="Departamento" readonly></v-select>
                  </v-col>
                  <v-col cols="12" lg="3">
                    <v-select v-model="postulante.id_ubicacion2" :items="provincias" item-text="nombre_ubicacion2"
                      item-value="id" label="Provincia" readonly></v-select>
                  </v-col>
                  <v-col cols="12" lg="3">
                    <v-select v-model="postulante.id_ubicacion3" :items="distritos" item-text="nombre_ubicacion3"
                      item-value="id" label="Distrito" readonly></v-select>
                  </v-col>

                  <v-col cols="12" lg="3">
                    <v-text-field v-model="postulante.observacion_domicilio" label="Dirección" readonly></v-text-field>
                  </v-col>

                  <v-col cols="12" lg="3">
                    <v-text-field v-model="postulante.posee_discapacidad" label="Posee discapacidad"
                      readonly></v-text-field>
                  </v-col>

                  <v-col cols="12" lg="3">
                    <v-select v-model="postulante.tipo_de_discapacidad" label="Tipo de discapacidad"
                      :items="listTipoDiscapacidades" item-value="id" item-text="desc_discapacidad" readonly></v-select>
                  </v-col>

                  <v-col cols="12" lg="3">
                    <v-text-field v-model="postulante.codigo_de_certificado" label="Código de certificado"
                      readonly></v-text-field>
                  </v-col>

                  <v-col cols="12" lg="3">
                    <v-text-field v-model="postulante.cel_postulante" label="Teléfono móvil" readonly></v-text-field>
                  </v-col>
                  <v-col cols="12" lg="3">
                    <v-text-field v-model="postulante.telf_postulante" label="Teléfono fijo" readonly></v-text-field>
                  </v-col>
                  <v-col cols="12" lg="3">
                    <v-text-field v-model="postulante.correo_postulante" label="Correo electrónico" readonly></v-text-field>
                  </v-col>
                  <v-col cols="12" lg="3">
                    <v-text-field v-model="postulante.cod_estudiante" label="Código de estudiante (SIAGIE)"
                      readonly></v-text-field>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-radio-group v-model="postulante.vive_con" readonly>
                      <template v-slot:label>
                        <div><strong>Vive con:</strong></div>
                      </template>
                      <v-radio value="papa">
                        <template v-slot:label>
                          <div>Papá</div>
                        </template>
                      </v-radio>
                      <v-radio value="mama">
                        <template v-slot:label>
                          <div>Mamá</div>
                        </template>
                      </v-radio>
                      <v-radio value="ambos">
                        <template v-slot:label>
                          <div>Ambos</div>
                        </template>
                      </v-radio>
                      <v-radio value="otros">
                        <template v-slot:label>
                          <div>Otros</div>
                        </template>
                      </v-radio>
                    </v-radio-group>
                  </v-col>
                </v-row>
              </v-stepper-content>

              <v-stepper-content step="3">
                <v-card height="600px">
                  <v-alert dense border="left" class="text-center" color="#0277bd" dark>
                    <h3>Documentos requeridos</h3>
                  </v-alert>
                  <v-row>
                    <v-col>
                      <ComundataTablecomp :headers="headersDoc" :items="listDocReq">
                        <template v-slot:nombre="{ item, index }">
                          <strong>{{ item.nombre.replace(".pdf", "") }}</strong>
                        </template>
                        <template v-slot:ruta="{ item, index }">
                          <ButtonComp @click="openVisorPDF(doc_req_url[index])" verButton tooltip-text="Ver documento" />
                          <!-- <strong>{{ item.ruta }}</strong> -->
                        </template>
                      </ComundataTablecomp>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>

              <v-stepper-content step="4">
                <v-card height="600px">
                  <v-alert dense border="left" class="text-center" color="#0277bd" dark>
                    <h3>Cursos a cargo</h3>
                  </v-alert>

                  <h2 v-if="mostrarElemento ? true : false" class="text-center">{{ mensaje }}</h2>

                  <v-row>
                    <v-col v-for="(curso, index) in cursos" :key="index" cols="12" sm="12" md="4">
                      <v-card class="my-3" color="primary">
                        <v-card-title class="text-center">{{ curso.desc_curso }} </v-card-title>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </template>

        <ComunDialogComp v-model="dialogDocumentos" max-width="1000px" @close-modal="dialogDocumentos = false"
          title="Ver documento">
          <template v-slot:body>
            <v-row>
              <v-col cols="12">
                <!-- <iframe :src='verPdfDoc'></iframe> -->
                <iframe :src="verPdfDoc" type="application/pdf" width="100%" height="800px"></iframe>
              </v-col>
            </v-row>
          </template>
        </ComunDialogComp>

      </v-form>
    </template>


  </ComunDialogComp>
</template>

<script>
import axios, { API_URL, BUCKET_ORIGIN_SPACE } from "@/helpers/axios";
import { mapMutations, mapGetters, mapActions, mapState } from "vuex";
import ComunDialogComp from '../../../../components/ComponentsEst/ComunDialogComp.vue'
import ComundataTablecomp from '../../../../components/ComponentsEst/ComundataTablecomp.vue';
import ButtonComp from "../../../../components/ComponentsEst/TableButtonComp.vue";


export default {
  name: "DetallePostulante",
  components: {
    ComunDialogComp,
    ComundataTablecomp,
    ButtonComp
  },
  props: {
    postulante: {
      type: Object,
      default: Object,
    },
    estado: Boolean
  },
  data: () => ({
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
    paramComponente: { id_submodulo: 142, id_modulo: 5 }, //sud_modulo y modulo
    stepCurrent: 1,
    datoLogin: sessionStorage, // variables de sesion del usuario
    ////////////////////////////////////////////////////////
    servidor: API_URL,
    URL_SPACE: BUCKET_ORIGIN_SPACE,
    // modal detalles
    dialogDocumentos: false,
    verPdfDoc: null,
    dialog: false,
    listDocReq: [],
    doc_req_url: [],
    departamentos: [],
    provincias: [],
    distritos: [],
    departamentosFamiliar: [],
    provinciasFamiliar: [],
    distritosFamiliar: [],
    parentescos: [],
    nacionalidades: [],
    discapacidades: [],
    cursos: {},
    mensaje: 'No tiene cursos a cargo',
    mostrarElemento: false,
    infoCursos: {},
    listTipoDiscapacidades: [],
    headersDoc: [
      {
        text: "NOMBRE DOCUMENTO",
        value: "nombre",
        class: "header_datatable",
      },
      { text: "VER DOCUMENTOS", value: "ruta", class: "header_datatable" },
    ],
    sexos: [
      { nombre: "Masculino", abbr: "M" },
      { nombre: "Femenino", abbr: "F" },
    ],
  }),

  computed: {
    ...mapGetters("login", ["componenteEvento"]),
    ...mapGetters(["getTipoDocumentos", "getPaises", "getEstadosCiviles"]),
    ...mapState(["TiposDocumentos", "estadosCiviles"]),
  },

  created() {
    this.actualizarParamentro();
  },

  mounted() {
    this.GetAllProvinciasIdFamiliar(this.postulante.familiar.id_ubicacion1);
    this.GetAllDistritosIdFamiliar(this.postulante.familiar.id_ubicacion2);
    this.GetAllDepartamentosIdFamiliar(this.postulante.familiar.id_pais);
    this.GetAllProvinciasId(this.postulante.id_ubicacion1);
    this.GetAllDistritosId(this.postulante.id_ubicacion2);
    this.GetAllDepartamentosId(this.postulante.id_pais);
    this.GetNacionalidades(this.postulante.familiar.id_pais_nacimiento);
    this.getTipoDiscapacidades();
    this.GetTipoParentescos();
    this.getAllTiposDocumentos();
    this.getAllPaises();
    this.getAllTiposEstadosCiviles();
    this.cursosCargo();
    this.getDocumentosRequeridos();
  },

  watch: {
    estado(value) {

      if (value) {
        console.log(this.postulante);
        this.GetAllProvinciasIdFamiliar(this.postulante.familiar.id_ubicacion1);
        this.GetAllDistritosIdFamiliar(this.postulante.familiar.id_ubicacion2);
        this.GetAllDepartamentosIdFamiliar(this.postulante.familiar.id_pais);
        this.GetAllProvinciasId(this.postulante.id_ubicacion1);
        this.GetAllDistritosId(this.postulante.id_ubicacion2);
        this.GetAllDepartamentosId(this.postulante.id_pais);
        this.GetNacionalidades(this.postulante.familiar.id_pais_nacimiento);
        this.getTipoDiscapacidades();
        this.GetTipoParentescos();
        this.getAllTiposDocumentos();
        this.getAllPaises();
        this.getAllTiposEstadosCiviles();
        this.cursosCargo();
        this.getDocumentosRequeridos();
      } else {
        this.stepCurrent = 1;

      }
    }
  },

  methods: {
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
    //----- Validar accesos por perfil ------------
    ...mapActions("login", ["parametroComponente"]),
    ...mapActions([
      "getAllTiposDocumentos",
      "getAllPaises",
      "getAllTiposEstadosCiviles",
    ]),

    getDocumentosRequeridos() {
      this.listDocReq = JSON.parse(this.postulante.doc_adjuntos);
      this.doc_req_url = JSON.parse(this.postulante.uri);
    },

    async openVisorPDF(ruta) {
      this.verPdfDoc = this.URL_SPACE + '/' + ruta;
      this.dialogDocumentos = true;
    },
    actualizarParamentro() {
      this.parametroComponente(this.paramComponente);
    },

    cursosCargo() {
      if (this.postulante.cursos_a_cargo == null) {
        this.mostrarElemento = true;
      }

      this.cursos = JSON.parse(this.postulante.cursos_a_cargo);

    },
    //  ------- MENSAJE DE SISTEMA  --------
    ...mapMutations("mensajeSis", ["setEnviarMens"]),
    ////////////////////////////////////////////////////////

    //------------ MOSTRAR DEPARTAMENTO POR ID DE País -------------
    async GetAllDepartamentosId(id) {
      try {
        let response = await axios.get(`/mantenimiento/ubicacion1/${id}`);
        this.departamentos = response.data;
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    async GetAllDepartamentosIdFamiliar(id) {
      try {
        let response = await axios.get(`/mantenimiento/ubicacion1/${id}`);
        this.departamentosFamiliar = response.data;
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    async GetAllProvinciasId(id) {
      try {
        let response = await axios.get("/mantenimiento/ubicacion2/" + id + "");
        this.provincias = response.data;
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    async GetAllProvinciasIdFamiliar(id) {
      try {
        let response = await axios.get("/mantenimiento/ubicacion2/" + id + "");
        this.provinciasFamiliar = response.data;
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    async GetAllDistritosId(id) {
      try {
        let response = await axios.get("/mantenimiento/ubicacion3/" + id + "");
        this.distritos = response.data;
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    async GetAllDistritosIdFamiliar(id) {
      try {
        let response = await axios.get("/mantenimiento/ubicacion3/" + id + "");
        this.distritosFamiliar = response.data;
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    async GetTipoParentescos() {
      try {
        let response = await axios.post(
          "/administrativo/alumno/getTipoParentescos",
          {
            idColegio: this.idColegio,
            idPais: this.idPaisUser,
          }
        );
        response = response.data;
        if (response.messageT === "S") {
          this.parentescos = response.payload;
        }
      } catch (e) {
        this.setEnviarMens({
          tipo: "E",
          mensaje: `No se pudo cargar lista de parentescos`,
          tiempo: null,
        });
      }
    },

    async GetNacionalidades(idPais) {
      let response = await axios.get(
        "/sistema/usuarioManager/getNacionalidades/" + idPais
      );
      let data = response.data;
      if (data.messageT == "S") {
        this.nacionalidades = data.payload;
      } else {
        this.setEnviarMens({
          tipo: "E",
          mensaje: "No se encontró nacionalidades.",
          tiempo: null,
        });
      }
    },

    async getTipoDiscapacidades() {
      try {
        let response = await axios.post(
          "/administrativo/alumno/getTipoDiscapacidades",
          {
            idColegio: this.idColegio,
          }
        );

        response = response.data;


        if (response.messageT === "S") {
          this.listTipoDiscapacidades = response.payload;
        }
      } catch (e) {
        console.log(e);
        this.setEnviarMens({
          tipo: "E",
          mensaje: `No se pudo cargar lista de discapacidades`,
          tiempo: null,
        });
      }
    },


    cerrarModal() {
      this.stepCurrent = 1;
      this.mostrarElemento = false,
        this.$emit('close');
    }
  },
};
</script>

<style scoped>
#text {
  color: #ffffff;
  padding: 1%;
  padding-left: 10%;
}
</style>
